function bindTryBeforeYouBuyButtons() {
  const tryBeforeYouBuyProductCards = document.querySelectorAll<HTMLDivElement>(
    '.product-card--wrapper[data-tbyb="true"]',
  );

  tryBeforeYouBuyProductCards.forEach((productCard) => {
    const cardAtc = productCard.querySelector<HTMLButtonElement>('.product-card--add-to-cart');

    if (!cardAtc) return;

    cardAtc.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const productId = productCard.getAttribute('data-product-id');

      if (!productId) {
        console.error('No product ID found for product card');
        return;
      }

      const productProperties = window.tbyb.productProperties[productId];

      if (!productProperties) {
        console.error('No product properties found for product ID', productId);
        return;
      }

      // Replace window.TryWithMirra.productProperties with productProperties
      window.TryWithMirra.productProperties = productProperties;
      window.tryWithMirraClicked(e);
    });
  });
}

if (document.readyState === 'complete') {
  bindTryBeforeYouBuyButtons();
} else {
  document.addEventListener('DOMContentLoaded', bindTryBeforeYouBuyButtons);
}
